<template>
  <a-card class="Report">
    <a-form-model layout="inline" class="search-form" :model="searchForm">
      <a-form-model-item label="报告名称">
        <a-input :maxLength="30" allowClear v-model="searchForm.reportName" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item style="margin-right: 35px">
        <a-button @click="getList(1)" type="primary" html-type="button"> 查询 </a-button>
        <a-button @click="searchReset" style="margin-left: 10px"> 重置 </a-button>
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="openModel()" icon="plus" v-if="![1, 4].includes($store.getters['course/getSeriesInfo']().status)" type="primary">添加模板 </a-button>
      </a-form-model-item>
    </a-form-model>
    <a-table :loading="table.tableLoading" :columns="columns" :data-source="table.tableDataSource" class="components-table-demo-nested" :pagination="table.tablePagination">
      <div slot="courseChildName" slot-scope="text, record">
        {{ text.reportCourseSessions.filter(f => f.isSelected).map((m) => m.name).join(' ') }}
      </div>
      <div slot="action" slot-scope="text, record" class="operate">
        <a-button type="link" icon="edit" :disabled="[1].includes($store.getters['course/getSeriesInfo']().status)" @click="edit(record)"> 编辑</a-button>

        <a-popconfirm title="确定删除？" :disabled="[1, 4].includes($store.getters['course/getSeriesInfo']().status)" @confirm="deleteReport(record)">
          <a-button type="link" icon="delete" danger :disabled="[1, 4].includes($store.getters['course/getSeriesInfo']().status)"> 删除</a-button>
        </a-popconfirm>
      </div>
    </a-table>
    <a-modal
      v-model="modal.visible"
      :title="modal.title"
      destroyOnClose
      :confirm-loading="modal.confirmLoading"
      :footer="$store.getters['course/getSeriesInfo']().status === 4 ? null : undefined"
      @ok="modleOk"
      width="900px"
      @cancel="closeModal"
      centered
    >
      <a-form-model
        ref="ruleForm"
        :class="$store.getters['course/getSeriesInfo']().status === 4 && 'no-click'"
        :model="modal.form"
        :rules="modal.rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="报告名称" prop="reportName">
          <a-input v-model.trim="modal.form.reportName" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item ref="reportTemplateId" label="报告模板" prop="reportTemplateId">
          <a-tree-select
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择"
            :tree-data="modal.reportTemplateList"
            :replaceFields="{ children: 'reportTemplates', title: 'name', key: 'id', value: 'id' }"
            allow-clear
            treeNodeFilterProp="title"
            v-model="modal.form.reportTemplateId"
          />
        </a-form-model-item>
        <a-form-model-item v-if="$store.getters['course/getCourseInfo']().courseType !== 2" label="课时关联" prop="courseSessionIds">
          <a-table
            bordered
            rowKey="id"
            :row-selection="rowSelection"
            :loading="modal.table.tableLoading"
            :columns="modal.columns"
            :data-source="modal.table.tableDataSource"
            :pagination="{ ...modal.table.tablePagination, size: 'small' }"
          >
          </a-table>
        </a-form-model-item>
        <a-form-model-item label="报告生成频率" v-if="$store.getters['course/getCourseInfo']().courseType == 2">
          每
          <a-input-number
            :disabled="this.modal.title == '编辑报告'"
            v-model="modal.form.reportFrequency"
            :min="1"
            style="width: 160px"
            :precision="0"
            :max="9999"
            placeholder="请输入整数"
          ></a-input-number>
          课时生成一次报告
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import MixinStting from '../mixinSetting'

const columns = [
  { title: '报告名称', dataIndex: 'reportName', align: 'center' },
  { title: '模板名称', dataIndex: 'reportTemplate.name', align: 'center' },
  { title: '关联课时', scopedSlots: { customRender: 'courseChildName' }, align: 'center' },
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, align: 'center' },
]
export default {
  name: 'Report',
  mixins: [MixinStting],
  data() {
    return {
      searchForm: {
        reportName: undefined,
      },
      columns, //报告表头
      table: tableRelevant.call(this, this.getList),

      modal: {
        visible: false,
        confirmLoading: false,
        title: '添加报告',
        form: {
          id: undefined,
          courseId: this.$store.getters['course/getCourseInfo']().id,
          reportName: '',
          reportTemplateId: undefined,
          courseSessionIds: [],
          reportFrequency: undefined,
        },
        rules: {
          reportName: [{ required: true, message: '请填写报告名称', trigger: 'blur' }],
          reportTemplateId: [{ required: true, message: '请选择报告模板', trigger: 'change' }],
          courseSessionIds: [{ type: 'array', required: true, message: '请选择课时', trigger: 'change' }],
        },
        columns: [
          { title: '课时', dataIndex: 'displayOrder', align: 'center' },
          { title: '名称', dataIndex: 'name', align: 'center' },
        ],
        table: tableRelevant.call(this, this.getCourseList),
        reportTemplateList: [],
      },
    }
  },
  created() {
    this.getList()
  },
  computed: {
    // 报告table选中数据回显
    rowSelection() {
      return {
        selectedRowKeys: this.modal.form.courseSessionIds,
        onChange: (selectedRowKeys, selectedRows) => {
          const arr = []
          this.modal.form.courseSessionIds = selectedRowKeys
          this.modal.table.selectedRows.concat(selectedRows).forEach((f) => {
            if (this.modal.form.courseSessionIds.indexOf(f.id) > -1 && !arr.some((s) => s.id === f.id)) {
              arr.push(f)
            }
          })
          this.modal.table.selectedRows = arr.sort((a, b) => a.displayOrder - b.displayOrder)
        },
      }
    },
  },
  methods: {
    // 获取报告table数据
    getList() {
      const Params = {
        CourseIds: this.$store.getters['course/getCourseInfo']().id,
        ...this.searchForm,
      }
      this.table.tableLoading = true
      this.$http.CourseResource.CourseReportsList(Params)
        .then((res) => {
          this.table.tableDataSource = res.data
          this.table.tablePagination.total = res.data.length
        })
        .finally(() => (this.table.tableLoading = false))
    },
    // 关联课时数据
    getCourseList(page) {
      const params = {
        pageIndex: page || this.modal.table.tablePagination.current,
        pageSize: this.modal.table.tablePagination.pageSize,
        courseId: this.$store.getters['course/getCourseInfo']().id,
      }
      this.modal.table.tableLoading = true
      this.$http.CourseResource.getCourseSessions(params).then((res) => {
          const { data } = res
        this.modal.table.tableDataSource = data.items
        this.modal.table.tablePagination.current = data.pageIndex
        this.modal.table.tablePagination.total = data.totalCount
        }).finally(() => (this.modal.table.tableLoading = false))
    },
    // 报告模板
    getReportTemplate() {
      this.$http.ReportService.ReportTemplates({ Enabled: true, TemplateTypes: this.$store.getters['course/getCourseInfo']().courseType }).then((res) => {
        this.modal.reportTemplateList = res.data.map((m, i) => {
          m.id = i
          m.selectable = false
          m.name = m.templateGroup
          m.reportTemplates = m.reportTemplates.map((m1) => ({
            selectable: true,
            isLeaf: true,
            ...m1,
          }))
          return m
        })
      })
    },
    // 表单提交
    modleOk() {
      this.$message.destroy()
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const Ajax = this.modal.title === '添加报告' ? this.$http.CourseResource.CourseReportsAdd : this.$http.CourseResource.CourseReportsEdit
          this.modal.confirmLoading = true
          Ajax(this.modal.form)
            .then((res) => {
              this.$message.success(res.message)
              this.closeModal()
              this.getList(1)
            })
            .finally(() => {
              this.modal.confirmLoading = false
            })
        }
      })
    },
    // 打开添加弹窗
    openModel() {
      this.getCourseList(1)
      this.getReportTemplate()
      this.modal.title = '添加报告'
      this.modal.visible = true
    },
    // 关闭表单弹窗
    closeModal() {
      this.modal.visible = false
      this.modal.form = {

        id: undefined,
        courseId: this.$store.getters['course/getCourseInfo']().id,
        reportName: '',
        reportTemplateId: undefined,
        courseSessionIds: [],
        reportFrequency:undefined
      }
      this.$refs.ruleForm.resetFields()
    },
    // 编辑回显
    edit(record) {
      for (const key in this.modal.form) {
        if (typeof record[key] !== 'undefined') {
          this.modal.form[key] = record[key]
        }
      }
      this.modal.form.courseSessionIds = record.reportCourseSessions.filter((f) => f.isSelected).map((m) => m.id)
      this.modal.form.reportTemplateId = record.reportTemplate.id
      this.getCourseList(1)
      this.getReportTemplate()
      this.modal.title = '编辑报告'
      this.modal.visible = true
    },
    // 删除报告
    deleteReport(record) {
      this.table.tableLoading = true
      this.$http.CourseService.checkCourseReport(record.id)
        .then((res) => {
          this.$http.CourseResource.CourseReportsDelete(record.id)
            .then((res) => {
              this.$message.success('删除成功')
              this.$store.dispatch('course/setCourseStatus')
              this.getList()
            })
            .finally(() => {
              this.table.tableLoading = false
            })
        })
        .catch(() => {
          this.table.tableLoading = false
        })
    },
    // 重置
    searchReset() {
      this.searchForm.reportName = undefined
      this.getList()
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-pagination .ant-select-selection {
  border-color: #d9d9d9;
  box-shadow: 0 0 0 2px rgba(19, 194, 194, 0.2);
}

/deep/ .ant-pagination .anticon {
  color: rgba(0, 0, 0, 0.25);
}
</style>
